<template>
    <Navbar/>
    <Blog2Body/>
    <Footer/>
  </template>
  
  <script>
  import { defineComponent } from "vue";
  import Navbar from "@/components/NavbarBody.vue";
  import Blog2Body from "@/components/blog/Blog2Body.vue";
  import Footer from "@/components/FooterBody.vue"; 
  
  export default defineComponent({
    name: "Blog2View",
    components: {
      Navbar,
      Blog2Body,
      Footer
    },
  });
  </script>
  